export default __webpack_public_path__ + "static/media/020-pot.2569eb88.svg";